import links from "@/links/links";

export default {
  actions: {
    FETCH(meetingResolutionId) {
      return this.get(links.RESOLUTION_VOTE_FETCH(meetingResolutionId), {
        dataKey: "hydra:member",
      });
    },
    POST(item) {
      return this.post(links.RESOLUTION_VOTE_POST(), item);
    },
    PUT(item, save = true) {
      return this.put(links.RESOLUTION_VOTE_PUT(item.id), item, { save: save });
    },
  },
};
